import { inject, observer } from 'mobx-react'
import React from 'react'
import { ReactComponent as CheckLeft } from '../../../svg/chevron-left.svg'


@inject('workAreaStore', 'sidebarStore', 'illustrationStore') @observer
class IllustrationSlide extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      
    }
  }

  componentDidMount(){
    if(!this.props.illustrationStore.initFetched){
      this.props.illustrationStore.fetchCollections('', true)
    }
  }

  setSelectedCollection(id, close = false){
    this.props.illustrationStore.setSelectedCollection(id, close)
  }

  normalizeIllustration(icon){
    return {
      rawSVG: icon.parsedAsset,
      parsedSVG: true,
      assetColors: icon.assetColors
    }
  }

  insertIllustration(e, icon){
    e.preventDefault()
    const { workAreaStore } = this.props
    this.toggleFull()
    setTimeout(() => {
      const { pageHeight, pageWidth } = workAreaStore.getPageMeta()
      workAreaStore.insertSVGElement(icon, pageWidth, pageHeight, true)
    }, 0)
    return
  }

  componentWillUnmount(){
    this.props.illustrationStore.setInitFetch(false)
  }

  toggleFull(){
    if(this.props.sidebarStore.fullScreen){
      this.props.sidebarStore.toggleFullscreen()
      this.props.workAreaStore.setHidden(false)
    }
  }

  render(){
    const { collections, collectionsOnly, selectedCollection, loading, collectionLoading, fetched, searchTerm, empty } = this.props.illustrationStore
    return (
      <>
      {
        selectedCollection ? (
          <div onClick={() => this.setSelectedCollection(null, true)} className='illustrations-back'><CheckLeft /></div>
        ) : undefined
      }
      <div className='slide-wrapper'>
        {
          loading && !selectedCollection && this.props.illustrationStore.collections.length === 0 ? (
            <span className='illustration-loading'>
              <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
            </span>
          )
          :
          undefined
        }
        {
          !loading && this.props.illustrationStore.collections.length === 0 && this.props.illustrationStore.searchTerm ? (
            <div className='empty-result-wrapper no-results'>
              <span>No illustrations</span>
              <label className='gray'>Try searching for something else</label>
            </div>
          ) 
          :
          undefined
        }
      
        <div className={`illustrations${!collectionsOnly ? ' selected-collection' : ''}`}>
          {
            !selectedCollection && collectionsOnly ? (
              <div className='illustrations__collections'>
                {
                  collections.map(collection => (
                    <div 
                      key={collection._id}
                      className='illustrations__collection-meta'
                      onClick={() => this.setSelectedCollection(collection._id)}
                      >
                      <img src={collection.thumb} />
                      <div className='text-meta'>
                        <span className='gray title'>
                          {collection.title} <b>({collection.iconLength})</b>
                        </span>
                      </div>
                    </div>
                  ))
                }
              </div>
            )
            :
            (
              <div className='illustrations__collection'>
                {
                  collectionLoading || !selectedCollection.icons ? (
                    <span className='illustration-loading' style={{width: '300%'}}>
                      <img src="https://mediamodifier.com/gfx/mm-logo.svg" className='logo-loader'/>
                    </span>
                  )
                  :
                  (
                    selectedCollection.icons.map((icon) => {
                      const normalized = this.normalizeIllustration(icon)
                      return (
                        <div 
                          key={icon._id}
                          className="illustrations__illustration-meta"
                          onClick={e => this.insertIllustration(e, normalized)}
                          onMouseDown={e => this.props.sidebarStore.setSelectedItem({...normalized, type: 'photo'}, 'illustration', e)}
                          draggable
                          onDrop={() => false}
                        >
                          <img src={URL.createObjectURL(new Blob([icon.svg], {type: 'image/svg+xml'}))} />
                        </div>
                      )
                    })
                  )
                }
              </div>
            )
          }
        </div>
        {
          !loading && this.props.illustrationStore.collections.length > 0 && empty && !selectedCollection ? (
            <div className='empty-result-wrapper end-results'>
              <span>That's it...</span>
              <label className='gray'>You've reached the end!</label>
            </div>
          ) 
          :
          undefined
        }
      </div>
      </>
    )
  }


}

export default IllustrationSlide